import React from "react";
import { connect } from "react-redux";

import Header from "components/organisms/header/index.jsx";
import Footer from "components/organisms/footer/index.jsx";
import FormHero from "components/organisms/formHero/index.jsx";
import FormContent from "components/organisms/formContent/index.jsx";

import Button from "components/atoms/button/index.jsx";
import FormCol from "components/molecules/formCol/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";
import FormWizard from "components/organisms/formWizard/index.jsx";
import FormWizardStep from "components/molecules/formWizardStep/index.jsx";
import SliderSelect from "components/molecules/sliderSelect/index.jsx";
import Selector from "components/molecules/selector/index.jsx";
import SelectorItem from "components/molecules/selectorItem/index.jsx";

import "./styles.scss";

class Credit extends React.Component {
  render() {
    const vehicle = {
      id: "4644",
      name: "suran",
      version: "1.6l higline",
      brand: "VOLKSWAGEN",
      brand_id: "35",
      price: "20020000",
    };
    return (
      <div className="credit">
        <Header />
        <FormHero vehicle={vehicle} />
        <FormContent>
          <FormWizard>
            <FormWizardStep name="Inicio" state="completed" />
            <FormWizardStep name="Financiación" state="active" />
            <FormWizardStep name="Datos Personales" state="" />
            <FormWizardStep name="Pago" state="" />
            <FormWizardStep name="Confirmar" state="" />
          </FormWizard>

          <h3>Selecciona una línea de financiación</h3>
          <h5>
            Cambia el importe de anticipo para obtener nuevas opciones de
            financiación.
          </h5>

          <FormCol single="true">
            <SliderSelect />
            <Selector>
              <SelectorItem value="Línea Única">
                <div>
                  <span>24 cuotas</span>
                </div>
                <div>
                  Cuota promedio <span>$ 5.235</span>
                </div>
              </SelectorItem>
              <SelectorItem value="Línea Única">
                <div>
                  <span>24 cuotas</span>
                </div>
                <div>
                  Cuota promedio <span>$ 5.235</span>
                </div>
              </SelectorItem>
              <SelectorItem value="Línea Única" active>
                <div>
                  <span>24 cuotas</span>
                </div>
                <div>
                  Cuota promedio <span>$ 5.235</span>
                </div>
              </SelectorItem>
              <SelectorItem value="Línea Única">
                <div>
                  <span>24 cuotas</span>
                </div>
                <div>
                  Cuota promedio <span>$ 5.235</span>
                </div>
              </SelectorItem>
            </Selector>

            <p className="disclamer">
              El pedido de aprobación no implica reserva de stock o compromiso
              de compra. <br />
              *La cuota no incluye el seguro del vehículo. El precio no incluye
              gastos de otorgamiento.
            </p>
          </FormCol>

          <FormActions back>
            <Button buttonText="Continuar" type="submit" />
          </FormActions>
        </FormContent>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Credit);
